// extracted by mini-css-extract-plugin
module.exports = {"container-label":"label_container-label__6dcKn"};